import { inject, Injectable, signal } from "@angular/core";
import { Router } from "@angular/router";

import { catchError, throwError } from "rxjs";

import { CallState, LoadingState } from "@core/models";
import { TenantService } from "@core/services";

import { AuthResponse } from "./models";
import { TokenService } from "./token.service";


@Injectable({ providedIn: 'root' })
export class LoginService {
  private readonly _tokenService = inject(TokenService);
  private readonly _router = inject(Router);


  callState = signal<CallState>(LoadingState.INIT);
  loggedInAccount = signal<AuthResponse | undefined>(undefined);

  private readonly _tenantService: TenantService = inject(TenantService);

  constructor() {
      this.loggedInAccount = this._tokenService.authResponse;
    }
  
  login(username: string, password: string) {
    this.callState.set(LoadingState.LOADING);
    const tenantId = this._tenantService.currentUriTenant();
    this._tokenService.authenticate(tenantId, username, password).pipe(
      catchError((error) => {
        this.callState.set({
          errorMsg: error?.error ?? 'Unknown error',
          //statusCode: error.statusCode,
        });
        return throwError(() => error)
    })).subscribe(x => {
      this.callState.set(LoadingState.LOADED);
      //this._router.navigate([tenantId, 'kiosk']); //, { queryParams: { returnUrl: this._state.url }, queryParamsHandling: 'merge' }
    });
  }

  logout(): void {
    this._tokenService.revoke();
    //this._notificationService.dismiss();

    const tenant = this._tenantService.currentUriTenant();;
    //this._router.navigate([tenant, 'login']);
  }

  reset(): void {
    this.callState.set(LoadingState.INIT);
  }
}